import { useQuery } from '@apollo/client';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import Conversation from '@website/components/chat/Conversation';
import { LayoutProps } from '@website/components/layouts/DefaultLayout';
import Header from '@website/components/layouts/Header';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { GetHostIdDocument } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';
import { Container } from 'react-bootstrap';
import Div100vh from 'react-div-100vh';

export default function HostConversation() {
  const { query } = useRouter();

  const { data } = useQuery(GetHostIdDocument, {
    variables: {
      hostURL: query.hostURL as string,
    },
    skip: !query.hostURL,
    pollInterval: 0, // Don't bother polling
  });

  if (!data) return <LoadingPage />;

  return (
    <RequiresAuth>
      <Conversation
        userID={data.hostByURL.id}
        conversationID={query.conversationID as string}
      />
    </RequiresAuth>
  );
}

/**
 * Custom layout the remove the footer and fix to 100 viewport height
 *
 * Note Safari/Chrome don't support 100vh by default (100dvh is coming but not widely available). Therefore we have to
 * use a javascript solution as well
 */
HostConversation.Layout = function Layout({ children }: LayoutProps) {
  return (
    <>
      <Header />
      <Container>
        <Div100vh>
          <div
            className="d-flex flex-column"
            style={{
              height: '95vh',
            }}
          >
            {children}
          </div>
        </Div100vh>
      </Container>
    </>
  );
};
